<template>
  <div>
    <Top />
    <div class="container container--mobile">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <Pagination :numberOfDots="4" :numberOfVisitedDots="2" />
          <div class="margin-top-75"></div>
          <div class="header-wrapper">
            <h4 class="text-left text-primary-fh">Skriv in koden</h4>
          </div>
          <p>Fyll i koden du fick med SMS.</p>
          <p>Fick du ingen kod? Gå tillbaka och kontrollera numret.</p>
          <input
            class="form-control form-control-lg"
            type="text"
            placeholder="Skriv in kod"
            v-model="phoneCode"
            :maxlength="codeLength"
            @input="enforceNumbers()"
            @keyup.enter="codeEntered()"
          />
          <div class="clearfix"></div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div class="clearfix"></div>
          <alert>Något gick fel, vänligen försök igen!</alert>
          <button class="btn btn-primary btn-lg btn-block" :disabled="!isCodeLengthValid" @click="codeEntered()">Nästa</button>
          <div class="clearfix"></div>
          <button class="btn btn-outline-dark btn-lg btn-block" @click="$router.go(-1)">&#8592; Tillbaka</button>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Alert />
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import Pagination from '../../src/components/Pagination'
import Alert from '../../src/components/Alert'
import config from '../../config/index.js'
import axios from '../plugins/axios'

export default {
  name: 'entercode',
  components: {
    Top,
    Bottom,
    Pagination,
    Alert
  },
  data () {
    return {
      phoneCode: '',
      codeLength: 6,
      isValidLength: false
    }
  },
  computed: {
    isCodeLengthValid () {
      return this.phoneCode.length === this.codeLength
    }
  },
  methods: {
    enforceNumbers () {
      this.phoneCode = this.phoneCode.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
    },
    codeEntered () {
      if (this.phoneCode.length === 6) {
        let loader = this.$loading.show()
        axios.postVerify(config.verifyPhoneCheckUri, sessionStorage.getItem('phone'), this.phoneCode).then((response) => {
          if (response.status === 200) {
            loader.hide()
            sessionStorage.removeItem('phone')
            this.$router.push('verifyinvite')
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          } else {
            loader.hide()
            console.log(error)
            this.$store.commit('setVisibility', true)
            setTimeout(() => this.$store.commit('setVisibility', false), config.msInterval)
          }
        })
      }
    }
  },
  beforeMount () {},
  metaInfo () {},
  async mounted () {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-bottom: 10vh;
  min-height: 60vh;
}
.page-item {
  color: transparent !important;
}
.margin-top-75 {
  margin-top: 75px;
}
.header-wrapper {
  display: flex;
}
.left-header {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/EnterCode.vue